import * as React from 'react';
export default function useConstant(fn) {
    var ref = React.useRef();
    if (!ref.current) {
        ref.current = { v: fn() };
    }
    return ref.current.v;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@xstate/react/es/useConstant.js
// module id = 439
// module chunks = 4